module.exports = __webpack_public_path__ + "assets/img/spider-hit.93d1a1cf.png";